import { Zap } from "lucide-react";
import { useT } from "@/i18n/I18nContext";

/** "We call you within 5 minutes — or your case review is free." */
export default function SpeedPromiseBadge({ className = "mt-6" }) {
  const t = useT();
  return (
    <div
      className={`inline-flex items-center gap-3 rounded-full border border-[#fcd9a3] bg-[#fff5e6] px-4 py-2 text-sm font-bold text-[#B45309] ${className}`}
      data-testid="speed-promise-badge"
    >
      <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-[#E85D04] text-white">
        <Zap className="h-3.5 w-3.5" />
      </span>
      <span className="leading-tight">{t("speed.promise")}</span>
    </div>
  );
}
